// extracted by mini-css-extract-plugin
export default {"ratepage":"Rate_ratepage__A1moy","ratecontainer":"Rate_ratecontainer__PTVP7"};